
var Data = {
  sotd: {
    result: null,
    fetch: (options={}) => {
      return m.request({
        method: "GET",
        url: "/news/update",
      }).then((items) => {
        Data.sotd.result = items
        return items
      }).catch((e) => {
        Data.sotd.error = e.message
        return e
      })
    }
  },
}

export { Data }
